import '@/pages/freePlay/styles/active-challenge.scss';

import React, { forwardRef, useMemo, useState } from 'react';

import { AchievementProgressProps } from '@/pages/freePlay/types';

import StarProgress from '@/pages/freePlay/components/category/StarProgress';

import WhiteMilepost from '@/assets/images/free-play/white-milepost.svg?react';

interface MilepostProgressProps {
	title?: string;
	levelImage?: string;
	levelName?: string;
	levelCompleted?: {
		name?: string;
		image?: string;
	};
	achievementRef?: React.RefObject<HTMLDivElement | null>;
	starProgress: AchievementProgressProps;
	className?: string;
}

const MilepostProgress = forwardRef<HTMLDivElement, MilepostProgressProps>(
	(
		{ title, levelImage, levelName, levelCompleted, achievementRef, starProgress, className },
		ref,
	) => {
		const [isTooltipVisible, setIsTooltipVisible] = useState(false);

		const tooltipOpen = useMemo(
			() => starProgress.tooltipOpen ?? isTooltipVisible,
			[starProgress.tooltipOpen, isTooltipVisible],
		);

		const handleShowTooltip = () => setIsTooltipVisible(true);
		const handleHideTooltip = () => setIsTooltipVisible(false);
		const milepostClassName = useMemo(
			() => ['active-challenge__milepost', className].filter(Boolean).join(' '),
			[className],
		);

		return (
			<div
				className={milepostClassName}
				ref={ref}
				onMouseEnter={handleShowTooltip}
				onMouseLeave={handleHideTooltip}
				onFocus={handleShowTooltip}
				onBlur={handleHideTooltip}
			>
				{title && <h3 className="active-challenge__milepost-title">{title}</h3>}
				{levelImage && (
					<img
						src={levelImage}
						alt={levelName || ''}
						className="active-challenge__milepost-achievement"
					/>
				)}
				<WhiteMilepost className="active-challenge__milepost-image" />
				{levelCompleted && (
					<div className="active-challenge__milepost-text">{levelCompleted.name}</div>
				)}
				{levelCompleted && levelCompleted.image && (
					<figure className="active-challenge__achievement" ref={achievementRef}>
						<img
							src={levelCompleted.image}
							alt={levelCompleted.name}
							className="active-challenge__achievement-image"
						/>
					</figure>
				)}
				<StarProgress {...starProgress} tooltipOpen={tooltipOpen} />
			</div>
		);
	},
);

export default MilepostProgress;
